import { memo, type FC } from "react";
import { ResponsiveBlockSwitcher } from "@/shared/Components";
import type { NoteEditorProps } from "@/features/NoteEditor/model/types";
import { NoteEditorDesktop } from "./desktop";
import { NoteEditorMobile } from "./mobile";

export const Layout: FC<NoteEditorProps> = memo(({ onSubmit, currentNote, onFileDelete }) => {
  return (
    <ResponsiveBlockSwitcher
      desktop={
        <NoteEditorDesktop
          onFileDelete={onFileDelete}
          currentNote={currentNote}
          onSubmit={onSubmit}
        />
      }
      mobile={<NoteEditorMobile currentNote={currentNote} onSubmit={onSubmit} />}
    />
  );
});
